/* ========================================================================
   Gievera: Back/Forward scroll + "Load more" state restore
   Fixes: returning from a product landed you at the end of page 1 instead of
   your spot. Saves the loaded product set + scroll position on leave and
   restores it on Back. Self-contained; only acts on collection/blog grids.
   ======================================================================== */
(function () {
  if (window.__gieveraPagRestore) return;
  window.__gieveraPagRestore = true;
  if (!('sessionStorage' in window)) return;

  function run() {
    var grid = document.getElementById('items-grid') || document.getElementById('blog-grid');
    if (!grid) return; // not a paginated grid page
    try { history.scrollRestoration = 'manual'; } catch (e) {}

    var KEY = 'eurus:pagstate:' + location.pathname + location.search;
    var navType = (performance.getEntriesByType('navigation')[0] || {}).type;

    if (navType === 'back_forward') {
      try {
        var raw = sessionStorage.getItem(KEY);
        if (raw) {
          var s = JSON.parse(raw);
          if (s && (Date.now() - s.t) < 1800000) { // 30 min freshness guard
            if (s.grid) grid.innerHTML = s.grid;
            if (s.btn) {
              var b = document.querySelector('[id^="btn-pagination-"]');
              if (b && b.id === s.btnId) b.innerHTML = s.btn;
            }
            var go = function () {
              var done = false;
              if (s.href) {
                var a = grid.querySelector('a[href="' + s.href + '"]');
                if (a) { a.scrollIntoView({ block: 'center' }); done = true; }
              }
              if (!done) window.scrollTo(0, s.y || 0);
            };
            requestAnimationFrame(function () { requestAnimationFrame(go); });
            [150, 400, 800].forEach(function (ms) { setTimeout(go, ms); });
          }
        }
      } catch (e) {}
    } else {
      try { sessionStorage.removeItem(KEY); } catch (e) {} // fresh visit starts clean
    }

    var lastHref = null;
    grid.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/products/"]');
      if (a) lastHref = a.getAttribute('href');
    }, true);

    window.addEventListener('pagehide', function () {
      try {
        var g = document.getElementById('items-grid') || document.getElementById('blog-grid');
        if (!g) return;
        var b = document.querySelector('[id^="btn-pagination-"]');
        sessionStorage.setItem(KEY, JSON.stringify({
          t: Date.now(),
          y: window.scrollY,
          href: lastHref,
          grid: g.innerHTML,
          btn: b ? b.innerHTML : null,
          btnId: b ? b.id : null
        }));
      } catch (e) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

if (!window.Eurus.loadedScript.has('pagination.js')) {
  window.Eurus.loadedScript.add('pagination.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xPagination", (sectionId) => ({
        loading: false,
        async loadData(url) {
          this.loading = true;
          try {
            const response = await fetch(url);
            const text = await response.text();
            const html = new DOMParser().parseFromString(text, 'text/html');
            const productGrid = html.getElementById('items-grid');
            if (!productGrid) return;
            const newProducts = Array.from(productGrid.querySelectorAll('.grid-item'));
            const target = document.getElementById('blog-grid') || document.getElementById('items-grid');
            if (!target) return;
            for (let i = 0; i < newProducts.length; i++) {
              if (i > 0) await new Promise(r => setTimeout(r, 40));
              const item = newProducts[i];
              item.classList.add('x-pagination-slide-up');
              target.appendChild(item);
              requestAnimationFrame(() => {
                requestAnimationFrame(() => item.classList.add('x-pagination-slide-up--in'));
              });
            }
            this._renderButton(html);
          } catch (e) {
            console.error(e);
          } finally {
            this.loading = false;
            requestAnimationFrame(() => {
              window.yotpoWidgetsContainer?.initWidgets?.();
            });
          }
        },
        _renderButton(html) {
          const destination = document.getElementById(`btn-pagination-${sectionId}`);
          const source = html.getElementById(`btn-pagination-${sectionId}`);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
          }
        }
      }));
    });
  });
}
